// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isString } from 'lodash';
// Core & Lab
import FormControl from '@mui/material/FormControl';
import { NumberField } from '../utils/input/numberField';
// Actions
import { updateDurationDays } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitDurationDays(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const duration_days = useSelector((state: AppState) => state.circuit.duration_days);

    useEffect(() => {
        dispatch(updateDurationDays(duration_days));
    },[circuitData]);

    const onDurationDaysChange = (event: { target: { value: any; }; }) => {
        dispatch(updateDurationDays(event.target.value));
    };
    const resetValue = () => {
        if (isNaN(isString(duration_days) ? parseInt(duration_days) : duration_days)){
            dispatch(updateDurationDays(0));
        }
    };

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(updateDurationDays(props.circuit.duration_day));
        }
    }, [props.circuit]);

    return (
        <FormControl  fullWidth variant={ 'outlined' }>
            <NumberField onBlur={resetValue}
                value={ duration_days }
                required
                id={ 'circuit-duration-days' }
                label={ t('shared.day(s)') }
                onChange={ onDurationDaysChange }
            />
        </FormControl>
    );
}
